
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import { expertiseGridClassName } from "../../../common/expertise/expertiseGrid";
import { ProfileEmpty, ProfileSection, ProfileSectionError } from "../common/ProfileSection";
import Expertise from "./Expertise";

export default function ExpertiseSection({ isDesktop, profileId }) {
	const [profile, setProfile] = useState({});
	const [expertises, setExpertises] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchExpertises();
		fetchProfile();
	}, []);

	function fetchExpertises() {
		api.listDoctorExpertises({
			profile_id: profileId,
		})
			.then((result) => {
				if (result["active_expertises"]) {
					setExpertises(result["active_expertises"]);
				}
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	function fetchProfile() {
		api.profileDetail({
			token: LoginHelper.getToken(),
			profile_id: profileId,
		})
			.then((result) => {
				setProfile(result);
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	if (profile.mode !== "doctor") {
		return null;
	}

	return (
		<ProfileSection title="تخصص‌ها">
			{expertises.length >= 1 ? (
				<div className={expertiseGridClassName(isDesktop)}>
					{expertises.map((expertise, index) => (
						<Expertise
							key={expertise.id}
							expertise={expertise}
							isDesktop={isDesktop}
							index={index}
						/>
					))}
				</div>
			) : (
				<ProfileEmpty>تخصصی ثبت نشده است</ProfileEmpty>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
